import {useMemo} from 'react';
import {IFacebookAccounts} from 'src/types/facebook/FacebookAccount';
import useSWR, {SWRResponse} from 'swr';

export const useFacebookAccounts = (authToken: string | null): SWRResponse<IFacebookAccounts> => {
  const URL = useMemo(() => `${process.env.REACT_APP_BACKEND_URL}/facebook/accounts?auth=${authToken}`, [authToken]);
  return useSWR(authToken ? URL : null);
};
